export default {"src":"/_next/static/media/5_points_icon.f200fe4e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};